module.exports = __webpack_public_path__ + "public/images/about-7.6eb04dfbb5fb54cdc427f4f613e9c57f.jpeg";